import { createContext } from "react"
import useAuthenticatedUser from "@/hooks/authentication/useAuthenticatedUser";

export interface IAuthenticatedUserContext extends ReturnType<typeof useAuthenticatedUser> {
}

export const AuthenticatedUserContext = createContext<IAuthenticatedUserContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default AuthenticatedUserContext;